import React from "react";
import PriceSectionView from "components/common/PriceSectionView";

class PriceSettingsTable extends React.PureComponent {
  render() {
    const { items, handleEdit, handleRemove, handleOpenDuplicate, isEditing } =
      this.props;

    if (items.length === 0) {
      return <div>No Settings</div>;
    }

    return (
      <div>
        <div className="text-sm text-gray-800">{items.length} settings</div>

        <table className="border shadow table w-full table-fixed text-sm">
          <thead className="border-b bg-gray-200 text-xs text-blue-800">
            <tr>
              <th
                className="border px-2 py-1 text-left"
                style={{ width: "45%" }}
              >
                Targeting
              </th>
              <th className="border px-2 py-1 text-right">Price</th>
              <th className="border px-2 py-1 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white  text-gray-900">
            {items.map((item, index) => {
              return (
                <tr key={index} className="border-b hover:bg-gray-100">
                  <td className="whitespace-no-wrap border px-2 py-1 text-left">
                    <div className="flex w-full flex-col gap-1 overflow-x-auto">
                      {item.isSetForEverything && (
                        <div className="font-bold text-blue-600">
                          Set For Everything
                        </div>
                      )}
                      {item.targeting &&
                        item.targeting.advertisersAndBrands && (
                          <div>
                            <span className="text-gray-700">
                              Advertisers and Brands: (
                              {item.targeting.advertisersAndBrands.length}){" "}
                            </span>

                            <div className="leading-tight">
                              {JSON.stringify(
                                item.targeting.advertisersAndBrands
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </td>

                  <td className="border px-2 py-1 text-right">
                    <PriceSectionView
                      item={item}
                      currency={item.currency}
                      branded={item.branded}
                    ></PriceSectionView>
                  </td>

                  <td className="whitespace-no-wrap border px-2 py-1 text-right">
                    <div className="flex flex-wrap items-center justify-end gap-4">
                      <button
                        type="button"
                        className={
                          isEditing
                            ? "text-gray-400"
                            : "text-blue-600 hover:underline"
                        }
                        onClick={() => handleEdit({ setting: item }, index)}
                        disabled={isEditing}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className={
                          isEditing
                            ? "text-gray-400"
                            : "text-blue-600 hover:underline"
                        }
                        onClick={() => handleOpenDuplicate(item, index)}
                        disabled={isEditing}
                      >
                        Duplicate
                      </button>
                      <button
                        type="button"
                        className={
                          isEditing
                            ? "text-gray-400"
                            : "text-blue-600 hover:underline"
                        }
                        onClick={() => handleRemove(item, index)}
                        disabled={isEditing}
                      >
                        Remove
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default PriceSettingsTable;
